// Feedbacks
const FeedbacksModule = () => import('@pages/feedbacks/FeedbacksModule')
const MeetingAssistanceConfirmation = () =>
    import('@pages/feedbacks/MeetingAssistanceConfirmation')
const MeetingThanks = () => import('@pages/feedbacks/MeetingThanks')
const PremeetingForm = () => import('@pages/feedbacks/PremeetingForm')
const MeetingLoseLogin = () => import('@pages/feedbacks/MeetingLoseLogin')
const MeetingSatisfactionPage = () => import('@pages/feedbacks/MeetingSatisfactionPage')
const CouncilMeetingFinishGreetings = () => import('@pages/feedbacks/CouncilMeetingFinishGreetings')
const BrowserNotCompatible = () => import('@pages/feedbacks/BrowserNotCompatible')

export default {
    path: '/feedbacks',
    component: FeedbacksModule,
    children: [{
            path: 'meeting-assistance-confirmation',
            component: MeetingAssistanceConfirmation,
            name: 'meetingAssistanceConfirmation',
            props: true,
        },
        {
            path: 'meeting-thanks',
            component: MeetingThanks,
            name: 'meetingThanks',
        },
        {
            path: 'council-meeting-finish-greetings',
            component: CouncilMeetingFinishGreetings,
            name: 'councilMeetingFinishGreetings',
            props: true,
        },
        {
            path: 'pre-meeting',
            component: PremeetingForm,
            name: 'premeeting',
            props: true,
        },
        {
            path: 'meeting-lose-login',
            component: MeetingLoseLogin,
            name: 'meetingLoseLogin',
        },
        {
            path: 'meeting-satisfaction/:meta',
            component: MeetingSatisfactionPage,
            name: 'meetingSatisfaction',
            props: true
        },
        {
            path: 'browser-not-compatible',
            component: BrowserNotCompatible,
            name: 'browserNotCompatible',
        }
    ],
}
